import { ko } from "date-fns/locale";
import { Calendar } from "react-date-range";
import UI from "@mile-meeting/mile-ui";
import { useEffect, useRef, useState } from "react";

export const DateInput = ({
  value,
  onChange,
  maxDate,
}: {
  value: Date;
  onChange?: (value: Date) => void;
  maxDate?: Date;
}) => {
  const year = value.getFullYear();
  const month = value.getMonth() + 1;
  const date = value.getDate();
  const today: Date = new Date();
  const after365Days: Date = new Date();
  after365Days.setDate(today.getDate() + 365);
  const ref = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    const handler = (event: any) => {
      if (open && ref.current && !ref.current.contains(event.target)) {
        setOpen?.(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, [open]);

  return (
    <div style={{ display: "flex", gap: "8px", flexDirection: "column", flex: 1 }}>
      <div className="calendar-selector" style={{ position: "relative", width: "100%" }} onFocus={() => setOpen(true)}>
        <UI.Input
          prefixIcon="calendar"
          showPrefixIcon
          value={`${year}. ${month.toString().padStart(2, "0")}. ${date.toString().padStart(2, "0")}`}
          width={"100%"}
        />
        <div
          ref={ref}
          className="calendar-modal"
          style={{
            display: open ? "block" : "none",
            position: "absolute",
            boxShadow: "var(--alias-style-shadow-strong)",
            backgroundColor: "white",
            zIndex: 100,
            width: 356,
            left: 2,
          }}
        >
          <Calendar
            locale={ko}
            date={value}
            onChange={(date) => onChange?.(date)}
            minDate={today}
            maxDate={maxDate ?? after365Days}
          />
        </div>
      </div>
    </div>
  );
};

export default DateInput;
